import { useLazyQuery, useQuery } from '@apollo/client'
import { ALL_EVENT_ATTENDEES } from './operations'
import {
  SortDirectionEnum,
  AllEventAttendees,
  AllEventAttendeesVariables,
  AllEventAttendeesInput,
} from '../../types'
import { SortByType } from '../../constants'

type Sorter = {
  sortBy?: string
  direction?: SortDirectionEnum
}

interface Props {
  filter: AllEventAttendeesInput
  page: number
  pageLength: number
  sorter?: Sorter
}

export const useAllEventAttendees = ({ filter, page = 1, pageLength = 10, sorter }: Props) =>
  useQuery<AllEventAttendees, AllEventAttendeesVariables>(ALL_EVENT_ATTENDEES, {
    variables: {
      filterData: {
        ...filter,
      },
      pagination: {
        from: pageLength * (page - 1),
        length: pageLength,
        sortBy: sorter?.sortBy || SortByType.SAMPLE_TESTED_AT,
        direction: sorter?.direction || SortDirectionEnum.ASC,
      },
    },
  })

export const useLazyAllEventAttendees = ({
  onCompleted,
}: {
  onCompleted: (data: AllEventAttendees) => void
}) =>
  useLazyQuery<AllEventAttendees, AllEventAttendeesVariables>(ALL_EVENT_ATTENDEES, {
    onCompleted,
  })
